import React, { useState, useEffect } from "react";
import {
  Paper,
  Typography,
  Box,
  Avatar,
  ListItemButton,
  useMediaQuery,
  Skeleton,
  useTheme,
  List,
  Card,
  CardContent,
  Stack,
  Tooltip,
} from "@mui/material";
import { BusinessCenterRounded } from "@mui/icons-material";
import Key from "../../../src/clientVariables.json";
import moment from "moment";
import { getSolrJobsAction, selectedJobAction } from "../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../redux/selector";
import generateSolrQuery from "../../helpers/solr";
import LoadingSkeleton from "../loadingSkeletons/LoadingList";
import InfiniteScroll from "react-infinite-scroll-component";
import FilterListIcon from "@mui/icons-material/FilterList";

const InterestedCandidateJobs = ({ jobIds, handleListItemClick }) => {
  const dispatch = useDispatch();
  const { candidateDetails, selectedJob, recruiterInterestedCandidates } =
    useSelector(appSelector);
  const [jobs, setJobs] = useState([]);
  //const [selectedJob, setSelectedJob] = useState(null); // State to track selected job
  //  const [loading, setLoading] = useState(true); // State to track loading status
  const [error, setError] = useState(null);
  const [limit, setLimit] = useState(20);
  const theme = useTheme();
  const [firstTimeLoading, setFirstTimeLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const itemsScroll = [1, 2, 3, 4];
  const isDesktopXS = useMediaQuery(
    "(min-width: 992px) and (max-width: 1199px)"
  );
  const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg"));
  const isDesktopSmall = useMediaQuery(
    "(min-width: 1200px) and (max-width: 1439px)"
  );
  const isDesktopMedium = useMediaQuery(
    "(min-width: 1440px) and (max-width: 1919px)"
  );
  useEffect(() => {
    setFirstTimeLoading(true);

    const fetch = async () => {
      if (jobIds?.length > 0) {
        setPage(0);
        let solrURL = getSolrQuery(0);
        const data = await dispatch(getSolrJobsAction(solrURL));
        await setJobs(data);
      }
    };
    fetch();
    setTimeout(() => {
      setFirstTimeLoading(false);
    }, 2000);
  }, [jobIds]);
  useEffect(() => {
    if (jobs && jobs.length > 0 && jobs.length <= limit) {
      let firstJob = jobs?.[0];
      dispatch(selectedJobAction(firstJob));
    }
  }, [jobs]);
  const getSolrQuery = (updatedPage) => {
    setPage(updatedPage);

    const generatedSolrQuery = generateSolrQuery(
      {
        id: jobIds ? jobIds : "",
      },
      updatedPage,
      limit
    );
    return generatedSolrQuery;
  };
  const getMoreJobs = async () => {
    setLoading(true);
    if (jobs && jobs.length > 0) {
      let updatedPage = page + limit;

      setPage(updatedPage);
      let solrURL = getSolrQuery(updatedPage);
      const data = await dispatch(getSolrJobsAction(solrURL));
      await setJobs((prev) => [...prev, ...data]);
    }
    setLoading(false);
  };

  const HighlightedCompanyName = ({ companyName, inputValue }) => {
    const highlightLetters = (text, search) => {
      if (!search) {
        return <span>{text}</span>;
      }

      const regex = new RegExp(`(${search})`, "ig");
      const parts = text.split(regex);

      return parts.map((part, index) =>
        regex.test(part) ? (
          <span
            key={index}
            style={{ color: "#000", backgroundColor: "#ff0", fontWeight: 600 }}
          >
            {part}
          </span>
        ) : (
          <span key={index}>{part}</span>
        )
      );
    };

    const theme = useTheme();
    const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg"));

    return (
      <Typography
        sx={{
          fontSize: isDesktopLarge ? "12px" : "9px",
          fontWeight: 500,
          margin: 0,
          minWidth: isDesktopLarge ? "150px" : "110px",
          maxWidth: isDesktopLarge ? "150px" : "110px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {highlightLetters(companyName, inputValue)}
      </Typography>
    );
  };

  const getTimeAgo = (timestamp) => {
    const lastModifiedMoment = moment(timestamp);
    const now = moment();
    const diffInSeconds = now.diff(lastModifiedMoment, "seconds");

    if (diffInSeconds < 60) {
      return "a few seconds ago";
    } else {
      return lastModifiedMoment.fromNow();
    }
  };

  return firstTimeLoading ? (
    <LoadingSkeleton />
  ) : (
    <List sx={{ padding: 0 }}>
      <InfiniteScroll
        dataLength={jobs?.length || 0}
        next={getMoreJobs}
        hasMore={true}
        height={window.innerHeight - 100}
        className="infinityscroll"
        style={{ overflowY: "scroll", overflowX: "hidden" }}
        scrollableTarget="scrollableDiv"
        pullDownToRefreshThreshold={50}
      >
        {/* <Box sx={{ display:"flex",justifyContent:"end" }}>
                <FilterListIcon style={{ color: "rgba(0, 0, 0, 0.6)" }} />

              </Box> */}

        {jobs?.length > 0 ? (
          jobs.map((job, index) => (
            // <ListItemButton
            //     key={job?.id}
            //     selected={selectedJob?.id === job?.id}
            //     onClick={() => {
            //         dispatch(selectedJobAction(job));
            //     }}
            //     sx={{
            //         ".hide-icons": {
            //             display: "none",
            //         },
            //         "&:hover": {
            //             ".hide-icons": {
            //                 display: "block",
            //             },
            //         },
            //         padding: isDesktopLarge
            //             ? "10px 20px"
            //             : isDesktopMedium
            //                 ? "8px 16px"
            //                 : isDesktopSmall
            //                     ? "6px 12px"
            //                     : "6px 12px",
            //     }}
            // >
            //     <div style={{ display: "flex", gap: 10, width: "100%" }}>
            //         <Avatar
            //             sx={{
            //                 height: isDesktopLarge
            //                     ? "40px"
            //                     : isDesktopMedium
            //                         ? "35px"
            //                         : isDesktopSmall
            //                             ? "32px"
            //                             : "28px",
            //                 width: isDesktopLarge
            //                     ? "40px"
            //                     : isDesktopMedium
            //                         ? "35px"
            //                         : isDesktopSmall
            //                             ? "32px"
            //                             : "28px",
            //             }}
            //         >
            //             <BusinessCenterRounded
            //                 sx={{
            //                     color: "#fff",
            //                     height: isDesktopLarge
            //                         ? "24px"
            //                         : isDesktopMedium
            //                             ? "20px"
            //                             : isDesktopSmall
            //                                 ? "16px"
            //                                 : "14px",
            //                     width: isDesktopLarge
            //                         ? "24px"
            //                         : isDesktopMedium
            //                             ? "22px"
            //                             : isDesktopSmall
            //                                 ? "18px"
            //                                 : "16px",
            //                 }}
            //             />
            //         </Avatar>
            //         <Box
            //             sx={{
            //                 display: "flex",
            //                 gap: 1,
            //                 justifyContent: "space-between",
            //                 width: "100%",
            //                 alignItems: "center",
            //             }}
            //         >
            //             <Stack direction="column">
            //                 <Typography
            //                     sx={{
            //                         fontSize: isDesktopXS ? "10px" : "12px",
            //                         fontWeight: 600,
            //                         margin: 0,
            //                         width: isDesktopLarge
            //                             ? "200px"
            //                             : isDesktopMedium
            //                                 ? "150px"
            //                                 : isDesktopSmall
            //                                     ? "100px"
            //                                     : "80px",
            //                         whiteSpace: "nowrap",
            //                         overflow: "hidden",
            //                         textOverflow: "ellipsis",
            //                     }}
            //                 >
            //                     {job?.jobtitle}
            //                 </Typography>

            //                 <Box sx={{ display:'flex',justifyContent:"end"}}>
            //                     <HighlightedCompanyName
            //                         companyName={job?.company_name}
            //                     //inputValue={companyName}
            //                     />
            //                     <Typography
            //                         paragraph
            //                         sx={{
            //                             margin: 0,
            //                             color: "#757575",
            //                             fontWeight: 500,
            //                             fontSize: isDesktopLarge ? "0.65rem" : "0.60rem",
            //                             float:"right"
            //                         }}
            //                     >
            //                         {job && getTimeAgo(job.posted_date)}
            //                     </Typography>
            //                 </Box>

            //                 <Typography
            //                     sx={{
            //                         fontSize: isDesktopXS ? "9px" : "11px",
            //                         margin: 0,
            //                     }}
            //                 >
            //                     {job.location ? job.location : "N/A"}
            //                 </Typography>
            //             </Stack>

            //         </Box>
            //     </div>
            // </ListItemButton>
            <ListItemButton
              key={job?.id}
              selected={selectedJob?.id === job?.id}
              onClick={() => {
                dispatch(selectedJobAction(job));
              }}
              sx={{
                ".hide-icons": {
                  display: "none",
                },
                "&:hover": {
                  ".hide-icons": {
                    display: "block",
                  },
                },
                padding: isDesktopLarge
                  ? "10px 20px"
                  : isDesktopMedium
                  ? "8px 16px"
                  : isDesktopSmall
                  ? "6px 12px"
                  : "6px 12px",
              }}
            >
              <div style={{ display: "flex", gap: 10, width: "100%" }}>
                <Avatar
                  sx={{
                    height: isDesktopLarge
                      ? "40px"
                      : isDesktopMedium
                      ? "35px"
                      : isDesktopSmall
                      ? "32px"
                      : "28px",
                    width: isDesktopLarge
                      ? "40px"
                      : isDesktopMedium
                      ? "35px"
                      : isDesktopSmall
                      ? "32px"
                      : "28px",
                  }}
                >
                  <BusinessCenterRounded
                    sx={{
                      color: "#fff",
                      height: isDesktopLarge
                        ? "24px"
                        : isDesktopMedium
                        ? "20px"
                        : isDesktopSmall
                        ? "16px"
                        : "14px",
                      width: isDesktopLarge
                        ? "24px"
                        : isDesktopMedium
                        ? "22px"
                        : isDesktopSmall
                        ? "18px"
                        : "16px",
                    }}
                  />
                </Avatar>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    justifyContent: "space-between",
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  <Stack direction="column" sx={{ flexGrow: 1 }}>
                    <Typography
                      sx={{
                        fontSize: isDesktopXS ? "10px" : "12px",
                        fontWeight: 600,
                        margin: 0,
                        width: isDesktopLarge
                          ? "200px"
                          : isDesktopMedium
                          ? "150px"
                          : isDesktopSmall
                          ? "100px"
                          : "80px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {job?.jobtitle}
                    </Typography>

                    <HighlightedCompanyName companyName={job?.company_name} />

                    <Typography
                      sx={{
                        fontSize: isDesktopXS ? "9px" : "11px",
                        margin: 0,
                      }}
                    >
                    {job?.location ? job.location : (parseInt(job.remote) === 1 ? "Remote" : "N/A")}
                    </Typography>
                  </Stack>
                  <Typography
                    paragraph
                    sx={{
                      margin: 0,
                      color: "#757575",
                      fontWeight: 500,
                      fontSize: isDesktopLarge ? "0.65rem" : "0.60rem",
                      flexShrink: 0, // Ensures the timestamp does not shrink
                      textAlign: "right", // Aligns the timestamp to the right
                      marginLeft: "-20px",
                      marginTop: "5px",
                    }}
                  >
                    {job && getTimeAgo(job.posted_date)}
                  </Typography>
                </Box>
              </div>
            </ListItemButton>
          ))
        ) : (
          <Card>
            <CardContent sx={{ display: "flex", justifyContent: "center " }}>
              <Typography variant="body2" component="h2" gutterBottom>
                No Jobs Found
              </Typography>
              {/* Uncomment if additional message is needed */}
              {/* <Typography variant="body2" color="text.secondary">
                  Please search for a different job title or location.
                </Typography> */}
            </CardContent>
          </Card>
        )}

        {loading &&
          itemsScroll.map((i, index) => (
            <ListItemButton key={index} sx={{ alignItems: "start" }}>
              <Skeleton
                animation="wave"
                variant="circular"
                width={50}
                height={40}
              />
              <Stack direction="column" width="100%">
                <Skeleton
                  animation="wave"
                  height={20}
                  width="100%"
                  style={{ marginBottom: 6, marginLeft: 6 }}
                />
                <Skeleton
                  animation="wave"
                  height={10}
                  width="70%"
                  style={{ marginBottom: 6, marginLeft: 6 }}
                />
                <Skeleton
                  animation="wave"
                  height={10}
                  width="40%"
                  style={{ marginBottom: 6, marginLeft: 6 }}
                />
              </Stack>
            </ListItemButton>
          ))}
      </InfiniteScroll>
    </List>
  );
};

export default InterestedCandidateJobs;
